// export const BASE_URL = "http://35.154.249.50:4000";
// export const BASE_URL = "http://13.127.94.213:4000";
// export const BASE_URL = "http://3.108.65.195:4000";
// <<<<<<< HEAD
// export const BASE_URL = "https://saptavidhi-api.onrender.com";
// =======
//=========
// export const BASE_URL = "https://saptavidhi-api-1.onrender.com"; 
export const BASE_URL = "https://saptavidhi-harsh.onrender.com"; 
// export const BASE_URL = "http://192.168.100.140:4000"; 
// >>>>>>> 61493b078f7821f5624a3e72f64278f84728ce48
